import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../../../../services';

@Component({
    selector: 'app-company-user-tile',
    templateUrl: './company.user.tile.component.html'
})

export class CompanyUserTileComponent implements OnInit {
    @Input() companyId: number;
    isModelLoaded = false;
    totalUsers = 0;

    constructor(private userService: UserService) { }

    ngOnInit(): void {
        this.userService.getCompanyUsersCount(this.companyId)
            .subscribe(
                (data: any) => {
                    this.isModelLoaded = true;
                    this.totalUsers = data;
                },
                error => {
                    console.log('CompanyUserTileComponent laod failed');
                    console.log(error);
                });
    }
}
